import React from 'react'
import { useTranslation } from 'react-i18next'
import type { Project } from '../../../../lib/db/models'
import { ProjectIcon } from '../../../common/ProjectIcon'
import './ProjectDragOverlay.scss'

/** Höhe der Karte in px — `cardBesideCursor` setzt sie danach mittig neben den Zeiger. Wie in der SCSS. */
export const PROJECT_DRAG_CARD_HEIGHT = 34

export interface ProjectDragOverlayProps {
  project: Pick<Project, 'name' | 'icon' | 'iconColor'>
  /** Wie viele Unterprojekte mitgehen — zeigt „+N“, bei 0 nichts. */
  subprojectCount: number
  /** Statt des Projekt-Icons — eine Aufgabe aus „Favoriten“ zeigt ihr Zeichen (#210). */
  leading?: React.ReactNode
}

/**
 * **Die Karte am Zeiger**, wenn ein Projekt in der Sidebar gezogen wird (#185): Icon und
 * Name, dazu „+N“, wenn der Ast Unterprojekte mitnimmt. Steht im `DragOverlay` von
 * `ProjectsSection`; die Zeile selbst bleibt blass an ihrem Platz.
 *
 * @example
 * <DragOverlay><ProjectDragOverlay project={haus} subprojectCount={2} /></DragOverlay>
 */
export const ProjectDragOverlay: React.FC<ProjectDragOverlayProps> = ({ project, subprojectCount, leading }) => {
  const { t } = useTranslation()
  return (
    <div className="project-drag-overlay">
      <span className="project-drag-overlay__icon">
        {leading ?? <ProjectIcon icon={project.icon} iconColor={project.iconColor} size={20} />}
      </span>
      <span className="project-drag-overlay__name">{project.name || t('project.defaultName')}</span>
      {subprojectCount > 0 && <span className="project-drag-overlay__more">+{subprojectCount}</span>}
    </div>
  )
}
